import React from 'react';

import { IBaseIcon } from '../types';

export const ChooseIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.74423 2.74411C2.98211 2.50622 3.33973 2.43454 3.6508 2.56263L17.8175 8.39596C18.1277 8.52372 18.331 8.82544 18.3334 9.16093C18.3357 9.49635 18.1364 9.80028 17.828 9.93242L12.6075 12.1704C12.4111 12.2547 12.2548 12.411 12.1705 12.6074L9.93254 17.8279C9.80041 18.1362 9.49647 18.3356 9.16106 18.3333C8.82556 18.3309 8.52384 18.1276 8.39608 17.8173L2.56275 3.65068C2.43466 3.3396 2.50634 2.98199 2.74423 2.74411ZM9.18222 15.3483L10.6381 11.9506C10.891 11.3609 11.361 10.8908 11.9508 10.638L15.3484 9.18209L4.865 4.86487L9.18222 15.3483Z" />
  </svg>
);

export const TextIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.8327 4.99998V17.5H9.16602V4.99998H4.16602V3.33331H15.8327V4.99998H10.8327Z" />
  </svg>
);

export const WallIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.66602" y="9.16669" width="16.6667" height="1.66667" />
  </svg>
);

export const WallCornerIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.66699 15V6.66602H15V5H5V15H6.66699Z" />
  </svg>
);

export const WallTIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="13.334"
      y="15.8333"
      width="11.6667"
      height="1.66667"
      transform="rotate(-90 13.334 15.8333)"
    />
    <rect
      x="15"
      y="10.8333"
      width="10"
      height="1.66667"
      transform="rotate(180 15 10.8333)"
    />
  </svg>
);

export const WallXIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="9.16602"
      y="15.8333"
      width="11.6667"
      height="1.66667"
      transform="rotate(-90 9.16602 15.8333)"
    />
    <rect
      x="15.834"
      y="10.8333"
      width="11.6667"
      height="1.66667"
      transform="rotate(180 15.834 10.8333)"
    />
  </svg>
);

export const PointerIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.4773 9.16664L9.00732 4.69664L10.1857 3.51831L16.6673 9.99998L10.1857 16.4816L9.00732 15.3033L13.4773 10.8333H3.33398V9.16664H13.4773Z" />
  </svg>
);

export const VrIcon = ({ width = 20, height = 20 }: IBaseIcon): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.31152 11.4111H7.36523L8.81348 6.66699H13.1963C13.6812 6.66699 14.1 6.75468 14.4521 6.92969C14.8063 7.10258 15.0797 7.35114 15.2715 7.67578C15.4633 7.99836 15.5586 8.38147 15.5586 8.82422C15.5586 9.2732 15.4607 9.65465 15.2646 9.96875C15.0698 10.2788 14.7937 10.5153 14.4365 10.6797L15.7803 13.1445H14.0723L12.8877 10.9268H12.0859V13.1445H10.5205V6.7998L8.37988 13.1445H6.2959L4.11035 6.66699H5.8623L7.31152 11.4111ZM12.0859 9.69336H12.8584C13.0943 9.69332 13.2912 9.66267 13.4492 9.60156C13.6095 9.53831 13.7312 9.44389 13.8135 9.31738C13.8956 9.18884 13.9365 9.02433 13.9365 8.82422C13.9365 8.62391 13.8957 8.45787 13.8135 8.32715C13.7312 8.19433 13.6095 8.09563 13.4492 8.03027C13.2891 7.96287 13.0922 7.92876 12.8584 7.92871H12.0859V9.69336Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.168 2.5C16.4689 2.50018 18.3338 4.36509 18.334 6.66602V13.333C18.334 15.6341 16.469 17.4998 14.168 17.5H5.83398C3.53295 17.4998 1.66797 15.6341 1.66797 13.333V6.66602C1.66814 4.36508 3.53306 2.50018 5.83398 2.5H14.168ZM5.83398 4.16602C4.45353 4.16619 3.33416 5.28556 3.33398 6.66602V13.333C3.33398 14.7136 4.45342 15.8328 5.83398 15.833H14.168C15.5485 15.8328 16.668 14.7136 16.668 13.333V6.66602C16.6678 5.28556 15.5484 4.16619 14.168 4.16602H5.83398Z"
    />
  </svg>
);

export const RacingSimIcon = ({
  width = 20,
  height = 20,
}: IBaseIcon): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.99935 1.66669C14.6017 1.66669 18.3327 5.39765 18.3327 10C18.3327 14.6024 14.6017 18.3334 9.99935 18.3334C5.39697 18.3334 1.66602 14.6024 1.66602 10C1.66602 5.39765 5.39697 1.66669 9.99935 1.66669ZM6.66602 10.8334L3.38436 10.8342C3.76072 13.8494 6.15071 16.2391 9.16602 16.6151V13.3334C7.78531 13.3334 6.66602 12.2141 6.66602 10.8334ZM16.6143 10.8342L13.3327 10.8334C13.3327 12.2141 12.2134 13.3334 10.8327 13.3334L10.8335 16.615C13.8484 16.2387 16.238 13.8491 16.6143 10.8342ZM11.666 10H8.33268V10.8334C8.33268 11.2936 8.70577 11.6667 9.16602 11.6667H10.8327C11.2929 11.6667 11.666 11.2936 11.666 10.8334V10ZM9.99935 3.33335C6.59966 3.33335 3.79432 5.87811 3.38426 9.16669H6.66602C6.66602 8.70644 7.03912 8.33335 7.49935 8.33335H12.4993C12.9596 8.33335 13.3327 8.70644 13.3327 9.16669H16.6144C16.2043 5.87811 13.399 3.33335 9.99935 3.33335Z" />
  </svg>
);

export const BilliardIcon = ({
  width = 20,
  height = 20,
}: IBaseIcon): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.0013 1.66699C14.6036 1.66699 18.3346 5.39795 18.3346 10.0003C18.3346 14.6027 14.6036 18.3337 10.0013 18.3337C5.39893 18.3337 1.66797 14.6027 1.66797 10.0003C1.66797 5.39795 5.39893 1.66699 10.0013 1.66699ZM10.0013 3.33366C6.3194 3.33366 3.33464 6.31843 3.33464 10.0003C3.33464 13.6822 6.3194 16.667 10.0013 16.667C13.6832 16.667 16.668 13.6822 16.668 10.0003C16.668 6.31843 13.6832 3.33366 10.0013 3.33366ZM10.0013 5.00033C12.7627 5.00033 15.0013 7.2389 15.0013 10.0003C15.0013 12.7617 12.7627 15.0003 10.0013 15.0003C7.23988 15.0003 5.0013 12.7617 5.0013 10.0003C5.0013 7.2389 7.23988 5.00033 10.0013 5.00033ZM10.0013 6.45866C8.85072 6.45866 7.91797 7.3914 7.91797 8.54199C7.91797 9.06824 8.1131 9.54899 8.43539 9.91416C7.96405 10.2953 7.66797 10.8461 7.66797 11.4587C7.66797 12.6092 8.71264 13.542 10.0013 13.542C11.29 13.542 12.3346 12.6092 12.3346 11.4587C12.3346 10.8461 12.0386 10.2953 11.5676 9.91566C11.8895 9.54899 12.0846 9.06824 12.0846 8.54199C12.0846 7.3914 11.1519 6.45866 10.0013 6.45866ZM10.0013 10.6253C10.6292 10.6253 11.0846 11.032 11.0846 11.4587C11.0846 11.8853 10.6292 12.292 10.0013 12.292C9.37339 12.292 8.91797 11.8853 8.91797 11.4587C8.91797 11.032 9.37339 10.6253 10.0013 10.6253ZM10.0013 7.70866C10.4616 7.70866 10.8346 8.08176 10.8346 8.54199C10.8346 9.00224 10.4616 9.37533 10.0013 9.37533C9.54105 9.37533 9.16797 9.00224 9.16797 8.54199C9.16797 8.08176 9.54105 7.70866 10.0013 7.70866Z" />
  </svg>
);

export const BoardGameIcon = ({
  width = 20,
  height = 20,
}: IBaseIcon): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.9167 0.239258C12.341 0.477658 11.7845 0.752914 11.25 1.06208C7.01562 3.51154 4.16673 8.08973 4.16667 13.3333H3.33333V16.6667H2.5V18.3333H16.6667V16.6667H15.8333V13.3333H14.8399C14.7149 12.7636 14.511 12.251 14.2074 11.7913C13.7353 11.0764 13.0223 10.4898 11.9914 10.0158C11.8826 9.96583 11.7728 9.91833 11.6621 9.87275C11.567 9.83367 11.5403 9.70992 11.6129 9.63725C11.6582 9.592 11.7145 9.59308 11.7723 9.60458L13.2333 9.89683L15.2443 10.2991C15.5961 10.3694 15.9533 10.2068 16.1313 9.89533L17.2106 8.00662C17.3843 7.70253 17.3494 7.32225 17.1233 7.05488L12.9167 2.08333V0.239258ZM14.1667 16.6667H5V15.0002H14.1667V16.6667ZM5.83333 13.3333C5.83339 8.98275 8.05633 5.14868 11.4321 2.90921L15.4742 7.68617L14.9823 8.54692L12.068 7.9641C11.4752 7.84553 10.8623 8.03103 10.4347 8.4585C9.49067 9.40208 9.87192 10.9392 11.0288 11.4143C12.0678 11.8413 12.5783 12.3159 12.863 12.7828C12.9609 12.9433 13.0453 13.1247 13.1146 13.3333H5.83333ZM11.6667 6.66667C12.1269 6.66667 12.5 6.29357 12.5 5.83333C12.5 5.3731 12.1269 5 11.6667 5C11.2064 5 10.8333 5.3731 10.8333 5.83333C10.8333 6.29357 11.2064 6.66667 11.6667 6.66667Z" />
  </svg>
);

export const ReceptionIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.66669C11.8408 1.66669 13.3328 3.15891 13.333 4.99969C13.333 5.88752 12.9848 6.69332 12.4189 7.29071C13.4802 7.87858 14.3041 8.84095 14.7139 9.99969H17.5V11.6667H16.333L15.333 16.6667H15.833V18.3337H4.16699V16.6667H4.66699L3.66602 11.6667H2.5V9.99969H5.28613C5.69583 8.84122 6.51921 7.87862 7.58008 7.29071C7.01445 6.69337 6.66699 5.88728 6.66699 4.99969C6.66719 3.15891 8.15917 1.66669 10 1.66669ZM6.36621 16.6667H13.6328L14.6338 11.6667H5.36621L6.36621 16.6667ZM10 8.33368C8.7666 8.33368 7.69075 9.00391 7.11426 9.99969H12.8857C12.3093 9.00391 11.2334 8.33368 10 8.33368ZM10 3.33368C9.07965 3.33368 8.33321 4.07939 8.33301 4.99969C8.33301 5.92017 9.07953 6.66669 10 6.66669C10.9205 6.66669 11.667 5.92017 11.667 4.99969C11.6668 4.07939 10.9204 3.33368 10 3.33368Z"
    />
  </svg>
);

export const CloakroomIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.49935 16.6666C2.26324 16.6666 2.06532 16.5868 1.9056 16.4271C1.74588 16.2673 1.66602 16.0694 1.66602 15.8333C1.66602 15.6944 1.69379 15.566 1.74935 15.4479C1.8049 15.3298 1.88824 15.2361 1.99935 15.1666L9.16602 9.79165V8.33331C9.16602 8.0972 9.24935 7.89928 9.41602 7.73956C9.58268 7.57984 9.78407 7.49998 10.0202 7.49998C10.3674 7.49998 10.6591 7.37498 10.8952 7.12498C11.1313 6.87498 11.2493 6.57637 11.2493 6.22915C11.2493 5.88192 11.1278 5.59026 10.8848 5.35415C10.6417 5.11804 10.3466 4.99998 9.99935 4.99998C9.65213 4.99998 9.35699 5.12151 9.11393 5.36456C8.87088 5.60762 8.74935 5.90276 8.74935 6.24998H7.08268C7.08268 5.44442 7.3674 4.75692 7.93685 4.18748C8.50629 3.61804 9.19379 3.33331 9.99935 3.33331C10.8049 3.33331 11.4924 3.61456 12.0618 4.17706C12.6313 4.73956 12.916 5.42359 12.916 6.22915C12.916 6.88192 12.725 7.46526 12.3431 7.97915C11.9612 8.49303 11.4577 8.8472 10.8327 9.04165V9.79165L17.9993 15.1666C18.1105 15.2361 18.1938 15.3298 18.2493 15.4479C18.3049 15.566 18.3327 15.6944 18.3327 15.8333C18.3327 16.0694 18.2528 16.2673 18.0931 16.4271C17.9334 16.5868 17.7355 16.6666 17.4993 16.6666H2.49935ZM4.99935 15H14.9993L9.99935 11.25L4.99935 15Z" />
  </svg>
);

export const RestroomIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.64 11.427L8.70667 4.66699H10.6667L8.70667 15.3337H6.93333L5.33333 8.48033L3.73333 15.3337H1.96L0 4.66699H1.96L3.02667 11.427L4.44 4.66699H6.22667L7.64 11.427ZM15.6667 4.66699C17.5867 4.66699 19.2 5.98699 19.7733 7.82699L17.88 8.50699C17.5733 7.50699 16.6933 6.80033 15.6667 6.80033C14.3733 6.80033 13.3333 7.92033 13.3333 9.29366V10.707C13.3333 12.0803 14.3733 13.2003 15.6667 13.2003C16.6933 13.2003 17.5733 12.4937 17.88 11.4937L19.7733 12.1737C19.2 14.0137 17.5867 15.3337 15.6667 15.3337C13.28 15.3337 11.3333 13.267 11.3333 10.707V9.29366C11.3333 6.73366 13.28 4.66699 15.6667 4.66699Z" />
  </svg>
);

export const LoungeIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.66732 2.5C4.82637 2.5 3.33398 3.99238 3.33398 5.83333V7.60502C1.89629 7.97505 0.833984 9.28017 0.833984 10.8333C0.833984 12.0681 1.50498 13.1445 2.50065 13.7205V15.8333V17.5H4.16732V16.6667H15.834V17.5H17.5007V15.8333V13.7205C18.4963 13.1445 19.1673 12.0681 19.1673 10.8333C19.1673 9.28017 18.105 7.97505 16.6673 7.60502V5.83333C16.6673 3.99238 15.1749 2.5 13.334 2.5H6.66732ZM15.0007 7.60502C13.563 7.97505 12.5007 9.28017 12.5007 10.8333H7.50065C7.50065 9.28017 6.43834 7.97505 5.00065 7.60502V5.83333C5.00065 4.91286 5.74684 4.16667 6.66732 4.16667H13.334C14.2545 4.16667 15.0007 4.91286 15.0007 5.83333V7.60502ZM7.50065 12.5H12.5007V13.3333H14.1673V10.8333C14.1673 9.91283 14.9135 9.16667 15.834 9.16667C16.7545 9.16667 17.5007 9.91283 17.5007 10.8333C17.5007 11.5577 17.0381 12.1762 16.3897 12.4054C16.0567 12.5231 15.834 12.8379 15.834 13.1911V15H4.16732V13.1911C4.16732 12.8379 3.94468 12.5231 3.61169 12.4054C2.96323 12.1762 2.50065 11.5577 2.50065 10.8333C2.50065 9.91283 3.24684 9.16667 4.16732 9.16667C5.08779 9.16667 5.83398 9.91283 5.83398 10.8333V13.3333H7.50065V12.5Z" />
  </svg>
);

export const BarIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.834 9.16661C16.2942 9.16661 16.6673 9.53971 16.6673 9.99994V10.8333C17.0435 10.8333 17.4149 10.918 17.7537 11.0815C18.0926 11.245 18.3904 11.4828 18.6245 11.7773C18.8586 12.0718 19.0234 12.4154 19.1063 12.7823C19.1892 13.1493 19.1878 13.5307 19.103 13.8972C19.0182 14.2635 18.8518 14.6059 18.6164 14.899C18.3807 15.1923 18.0812 15.4291 17.7415 15.5908C17.402 15.7523 17.0303 15.8352 16.6543 15.8333C16.5457 15.8327 16.4375 15.8242 16.3304 15.8097C15.6928 17.2938 14.2183 18.3333 12.5007 18.3333C10.1995 18.3333 8.33398 16.4678 8.33398 14.1666V9.99994C8.33398 9.53971 8.70708 9.16661 9.16732 9.16661H15.834ZM10.0007 14.1666C10.0007 15.5473 11.1199 16.6666 12.5007 16.6666C13.8814 16.6666 15.0007 15.5473 15.0007 14.1666V10.8333H10.0007V14.1666ZM16.6673 14.1666C16.6673 14.2313 16.6645 14.2955 16.6616 14.3595C16.8161 14.3603 16.9689 14.3266 17.1084 14.2602C17.2479 14.1938 17.3705 14.0966 17.4673 13.9762C17.5641 13.8557 17.6326 13.7149 17.6675 13.5644C17.7022 13.414 17.7031 13.2576 17.6691 13.107C17.6351 12.9564 17.5674 12.8153 17.4714 12.6944C17.3752 12.5735 17.2524 12.4759 17.1133 12.4088C16.9741 12.3417 16.8218 12.3063 16.6673 12.3063V14.1666Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33626 1.68265C7.54395 1.64072 7.75997 1.67932 7.9401 1.79088C8.12025 1.90246 8.25134 2.07859 8.30631 2.28323C8.36125 2.488 8.33567 2.70673 8.23551 2.89358L8.18018 2.98229L7.93115 3.33304H10.4173C10.7281 3.33305 11.028 3.44883 11.258 3.65774C11.4879 3.86665 11.6318 4.15415 11.6616 4.46341L11.6673 4.58304V5.83304L11.6649 5.90302C12.1165 6.06136 12.4499 6.47331 12.4958 6.96748L12.5007 7.08385V7.4997H2.50065V8.33304H7.30778C6.91089 8.77557 6.66738 9.35853 6.66732 9.9997L3.42188 10.0005L4.08838 16.6672H7.22965C7.52632 17.2914 7.93073 17.8541 8.41862 18.3322H4.08838C3.69681 18.3324 3.3176 18.1947 3.01742 17.9432C2.7173 17.6919 2.51469 17.3431 2.44613 16.9577L2.42985 16.8324L1.66325 9.16556C1.45973 9.16449 1.26316 9.08886 1.11149 8.95315C0.960018 8.81747 0.863269 8.63106 0.839681 8.42907L0.833984 8.33304V7.08304C0.833898 6.82407 0.914606 6.57171 1.06429 6.36038C1.21403 6.14899 1.42534 5.98886 1.66976 5.90302L1.66813 5.86803L1.66732 4.58304C1.66738 4.27244 1.78324 3.97315 1.99202 3.74319C2.20094 3.51317 2.48839 3.36856 2.79769 3.33873L2.91732 3.33304H5.90641L5.94303 3.26061L5.98779 3.19143L6.82113 2.01712C6.94379 1.84421 7.12847 1.72469 7.33626 1.68265ZM3.33398 5.83304H10.0007V4.9997H3.33398V5.83304Z"
    />
  </svg>
);

export const KitchenIcon = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.5 1.66669V18.3334H15.8333V12.5H12.5V6.66669C12.5 3.90526 14.7386 1.66669 17.5 1.66669ZM15.8333 3.77502C15.1417 4.16669 14.1667 5.14169 14.1667 6.66669V10.8334H15.8333V3.77502ZM7.5 11.5834V18.3334H5.83333V11.5834C3.93147 11.1973 2.5 9.51585 2.5 7.50002V2.50002H4.16667V8.33335H5.83333V2.50002H7.5V8.33335H9.16667V2.50002H10.8333V7.50002C10.8333 9.51585 9.40183 11.1973 7.5 11.5834Z" />
  </svg>
);

export const ArrowIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.172 11L10.808 5.63605L12.222 4.22205L20 12L12.222 19.778L10.808 18.364L16.172 13H4V11H16.172Z"
      fillOpacity="0.5"
    />
  </svg>
);

export const RotateIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.79513 2C4.59456 2 2 4.68628 2 8C2 11.3137 4.59456 14 7.79513 14C8.56556 14 9.31606 13.8439 10.0135 13.5445C10.6386 13.2761 11.2126 12.8961 11.71 12.4239L11.8929 12.2426L10.9823 11.2998C10.5637 11.7332 10.0668 12.0782 9.52022 12.3128C8.9785 12.5454 8.39553 12.6667 7.79513 12.6667C5.30578 12.6667 3.28781 10.5773 3.28781 8C3.28781 5.42266 5.30578 3.33334 7.79513 3.33334C10.1918 3.33334 12.1515 5.27003 12.2941 7.71431L11.4699 6.86194L10.5593 7.80475L12.9463 10.2762L15.3333 7.80475L14.4227 6.86194L13.5844 7.72944C13.4478 4.54128 10.9081 2 7.79513 2Z" />
  </svg>
);

export const VerticalLeftTextIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14 2H2V3.33333H14V2ZM10 6V10H12V6H10ZM8.66667 5.33333C8.66667 4.96515 8.96513 4.66667 9.33333 4.66667H12.6667C13.0349 4.66667 13.3333 4.96515 13.3333 5.33333V10.6667C13.3333 11.0349 13.0349 11.3333 12.6667 11.3333H9.33333C8.96513 11.3333 8.66667 11.0349 8.66667 10.6667V5.33333ZM6 6V12.6667H4V6H6ZM3.33333 4.66667C2.96515 4.66667 2.66667 4.96515 2.66667 5.33333V13.3333C2.66667 13.7015 2.96515 14 3.33333 14H6.66667C7.03487 14 7.33333 13.7015 7.33333 13.3333V5.33333C7.33333 4.96515 7.03487 4.66667 6.66667 4.66667H3.33333Z" />
  </svg>
);
export const VerticalCenterTextIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.9987 12.0003V4.00033H3.9987V12.0003H5.9987ZM3.33203 13.3337C2.96384 13.3337 2.66536 13.0352 2.66536 12.667V8.66699H1.33203V7.33366H2.66536V3.33366C2.66536 2.96547 2.96384 2.66699 3.33203 2.66699H6.66536C7.03356 2.66699 7.33203 2.96547 7.33203 3.33366V7.33366H8.66536V4.66699C8.66536 4.2988 8.96383 4.00033 9.33203 4.00033H12.6654C13.0336 4.00033 13.332 4.29881 13.332 4.66699V7.33366H14.6654V8.66699H13.332V11.3337C13.332 11.7019 13.0336 12.0003 12.6654 12.0003H9.33203C8.96383 12.0003 8.66536 11.7019 8.66536 11.3337V8.66699H7.33203V12.667C7.33203 13.0352 7.03356 13.3337 6.66536 13.3337H3.33203ZM9.9987 10.667H11.9987V5.33366H9.9987V10.667Z" />
  </svg>
);
export const VerticalRightTextIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 3.33333V10H4V3.33333H6ZM3.33333 2C2.96515 2 2.66667 2.29848 2.66667 2.66667V10.6667C2.66667 11.0349 2.96515 11.3333 3.33333 11.3333H6.66667C7.03487 11.3333 7.33333 11.0349 7.33333 10.6667V2.66667C7.33333 2.29848 7.03487 2 6.66667 2H3.33333ZM10 6V10H12V6H10ZM8.66667 5.33333C8.66667 4.96515 8.96513 4.66667 9.33333 4.66667H12.6667C13.0349 4.66667 13.3333 4.96515 13.3333 5.33333V10.6667C13.3333 11.0349 13.0349 11.3333 12.6667 11.3333H9.33333C8.96513 11.3333 8.66667 11.0349 8.66667 10.6667V5.33333ZM14 12.6667H2V14H14V12.6667Z" />
  </svg>
);
export const HorizontalLeftTextIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 14V2H3.33333V14H2ZM6 10H10V12H6V10ZM5.33333 8.66667C4.96515 8.66667 4.66667 8.96513 4.66667 9.33333V12.6667C4.66667 13.0349 4.96515 13.3333 5.33333 13.3333H10.6667C11.0349 13.3333 11.3333 13.0349 11.3333 12.6667V9.33333C11.3333 8.96513 11.0349 8.66667 10.6667 8.66667H5.33333ZM6 6H12.6667V4H6V6ZM4.66667 3.33333C4.66667 2.96515 4.96515 2.66667 5.33333 2.66667H13.3333C13.7015 2.66667 14 2.96515 14 3.33333V6.66667C14 7.03487 13.7015 7.33333 13.3333 7.33333H5.33333C4.96515 7.33333 4.66667 7.03487 4.66667 6.66667V3.33333Z" />
  </svg>
);
export const HorizontalCenterTextIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.33464 2.66634V1.33301H8.66797V2.66634H12.668C13.0362 2.66634 13.3346 2.96482 13.3346 3.33301V6.66634C13.3346 7.03454 13.0362 7.33301 12.668 7.33301H8.66797V8.66634H11.3346C11.7028 8.66634 12.0013 8.96481 12.0013 9.33301V12.6663C12.0013 13.0345 11.7028 13.333 11.3346 13.333H8.66797V14.6663H7.33464V13.333H4.66797C4.29978 13.333 4.0013 13.0345 4.0013 12.6663V9.33301C4.0013 8.96481 4.29978 8.66634 4.66797 8.66634H7.33464V7.33301H3.33464C2.96645 7.33301 2.66797 7.03454 2.66797 6.66634V3.33301C2.66797 2.96482 2.96645 2.66634 3.33464 2.66634H7.33464ZM5.33464 9.99967V11.9997H10.668V9.99967H5.33464ZM4.0013 5.99967H12.0013V3.99967H4.0013V5.99967Z" />
  </svg>
);
export const HorizontalRightTextIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.6667 14V2H14V14H12.6667ZM6 10H10V12H6V10ZM5.33333 8.66667C4.96515 8.66667 4.66667 8.96513 4.66667 9.33333V12.6667C4.66667 13.0349 4.96515 13.3333 5.33333 13.3333H10.6667C11.0349 13.3333 11.3333 13.0349 11.3333 12.6667V9.33333C11.3333 8.96513 11.0349 8.66667 10.6667 8.66667H5.33333ZM3.33333 6H10V4H3.33333V6ZM2 3.33333C2 2.96515 2.29848 2.66667 2.66667 2.66667H10.6667C11.0349 2.66667 11.3333 2.96515 11.3333 3.33333V6.66667C11.3333 7.03487 11.0349 7.33333 10.6667 7.33333H2.66667C2.29848 7.33333 2 7.03487 2 6.66667V3.33333Z" />
  </svg>
);
